import { createApp } from "vue";
import App from "./App.vue";
// import router from "./router";

import "remixicon/fonts/remixicon.css";

import Admin from "@/components/Admin";
import NftMint from "@/components/NftMint";
import { createRouter, createWebHistory } from "vue-router";
import MyReapers from "@/components/MyReapers";
import AllReapers from "@/components/AllReapers";
import Info from "@/components/InfoStaking";
import InfoTokenomics from "@/components/InfoTokenomics";
import CardsManager from "@/components/CardsManager";
import Staking from "@/components/Staking";

export let app = createApp(App);

const routes = [
  { path: "/admin", component: Admin },
  { path: "/mint", component: NftMint },
  { path: "/my-reapers", component: MyReapers },
  { path: "/all-reapers", component: AllReapers },
  { path: "/staking", component: Staking },
  { path: "/cards", component: CardsManager },
  { path: "/info", component: Info },
  { path: "/tokenomics", component: InfoTokenomics },
  { path: "/", component: CardsManager },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

app.use(router);

app.mount("#app");
